import {
  Backdrop,
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  InputAdornment,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { compose } from "redux";
import Logo from "../../Components/Logo";
import PrimaryButton from "../../Components/UI/Buttons/PrimaryButton";
import actions from "../../Stores/Auth/actions";
const loginAction = actions.login;

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "20px",
    background:
      "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%)",
    position: "relative",
    overflow: "hidden",
  },
  backgroundElement1: {
    position: "absolute",
    top: "-10%",
    right: "-10%",
    width: "300px",
    height: "300px",
    background:
      "linear-gradient(45deg, rgba(59, 130, 246, 0.1), rgba(147, 51, 234, 0.1))",
    borderRadius: "50%",
    filter: "blur(40px)",
  },
  backgroundElement2: {
    position: "absolute",
    bottom: "-15%",
    left: "-15%",
    width: "400px",
    height: "400px",
    background:
      "linear-gradient(135deg, rgba(34, 197, 94, 0.1), rgba(59, 130, 246, 0.1))",
    borderRadius: "50%",
    filter: "blur(50px)",
  },
  card: {
    maxWidth: "520px",
    width: "100%",
    padding: "48px",
    borderRadius: "24px",
    background: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255, 255, 255, 0.8)",
    boxShadow:
      "0 20px 60px rgba(0, 0, 0, 0.08), 0 8px 25px rgba(0, 0, 0, 0.04)",
    position: "relative",
    zIndex: 1,
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "40px",
  },
  logoWrapper: {
    width: "220px",
    filter: "drop-shadow(0 2px 12px rgba(0,0,0,0.08))",
  },
  headerSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "24px",
    gap: "16px",
  },
  iconContainer: {
    background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
    borderRadius: "50%",
    width: "56px",
    height: "56px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 20px rgba(59, 130, 246, 0.3)",
  },
  icon: {
    color: "#ffffff",
    fontSize: "28px",
  },
  title: {
    fontWeight: 700,
    color: "#1e293b",
    fontSize: "28px",
    letterSpacing: "-0.02em",
  },
  description: {
    textAlign: "center",
    color: "#64748b",
    marginBottom: "40px",
    fontSize: "16px",
    lineHeight: "1.6",
  },
  divider: {
    height: "1px",
    background: "linear-gradient(90deg, transparent, #e2e8f0, transparent)",
    marginBottom: "32px",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "24px",
  },
  fieldContainer: {
    background: "#f8fafc",
    borderRadius: "16px",
    padding: "8px",
    border: "1px solid #e2e8f0",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      background: "#ffffff",
      borderRadius: "12px",
    },
  },
  inputProps: {
    color: "#1e293b",
    fontSize: "16px",
    padding: "4px",
  },
  inputLabelProps: {
    color: "#64748b",
  },
  helperTextProps: {
    color: "#64748b",
  },
  forgotPasswordLink: {
    textDecoration: "none",
    color: "#3b82f6",
    fontSize: "14px",
    fontWeight: "500",
    transition: "color 0.3s ease",
    "&:hover": {
      color: "#1d4ed8",
      textDecoration: "underline",
    },
  },
  forgotPasswordContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
  },
  rememberMeLabel: {
    margin: 0,
    "& .MuiTypography-root": {
      color: "#64748b",
      fontSize: "14px",
      fontWeight: "500",
    },
  },
  rememberMeCheckbox: {
    color: "#3b82f6",
    "&.Mui-checked": {
      color: "#3b82f6",
    },
  },
  infoSection: {
    marginTop: "40px",
    padding: "20px",
    background: "linear-gradient(135deg, #f1f5f9, #e2e8f0)",
    borderRadius: "16px",
    border: "1px solid #cbd5e1",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
  },
  infoTitle: {
    color: "#475569",
    display: "block",
    marginBottom: "8px",
    fontWeight: "700",
    fontSize: "14px",
  },
  infoDescription: {
    color: "#64748b",
    fontSize: "13px",
    lineHeight: "1.5",
  },
}));

const Login = ({ login, isLoggingIn, error, isAuthenticated }) => {
  const classes = useStyles();
  const [show, setShow] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const history = useHistory();

  const onChange = (e) =>
    setCredentials({ ...credentials, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    // Include remember_me in credentials
    login({ ...credentials, remember_me: rememberMe }, history);
  };

  return (
    <Box className={classes.root}>
      {/* Background Elements */}
      <Box className={classes.backgroundElement1} />
      <Box className={classes.backgroundElement2} />

      {/* {isAuthenticated && <Redirect to="/d/review/listing" />} */}
      {isLoggingIn && (
        <Backdrop className={classes.backdrop} open>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      {/* Main Card */}
      <Box className={classes.card}>
        {/* Logo Section */}
        <Box className={classes.logoContainer}>
          <Box className={classes.logoWrapper}>
            <Logo variant="dark" redirect="#" size="default" />
          </Box>
        </Box>

        {/* Header Section */}
        <Box className={classes.headerSection}>
          <Box className={classes.iconContainer}>
            <LockOutlinedIcon className={classes.icon} />
          </Box>
          <Typography variant="h4" className={classes.title}>
            Sign In
          </Typography>
        </Box>

        <Typography variant="body1" className={classes.description}>
          Welcome back! Please sign in to your CareCentre.io account
        </Typography>

        <Box className={classes.divider} />

        {/* Form Section */}
        <form onSubmit={onSubmit}>
          <Box className={classes.formContainer}>
            <Box className={classes.fieldContainer}>
              <TextField
                size="medium"
                variant="outlined"
                name="email"
                label="Email Address"
                placeholder="Enter your email address"
                type="email"
                fullWidth
                autoFocus
                required
                value={credentials.email}
                onChange={onChange}
                className={classes.textField}
                InputProps={{
                  className: classes.inputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        <PersonOutlineOutlinedIcon
                          style={{ color: "#64748b" }}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  className: classes.inputLabelProps,
                }}
                FormHelperTextProps={{
                  className: classes.helperTextProps,
                }}
              />
            </Box>

            <Box className={classes.fieldContainer}>
              <TextField
                size="medium"
                variant="outlined"
                name="password"
                label="Password"
                placeholder="Enter your password"
                type={show ? "text" : "password"}
                fullWidth
                required
                value={credentials.password}
                onChange={onChange}
                className={classes.textField}
                InputProps={{
                  className: classes.inputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShow(!show)} edge="end">
                        {show ? (
                          <VisibilityIcon style={{ color: "#64748b" }} />
                        ) : (
                          <VisibilityOffIcon style={{ color: "#64748b" }} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  className: classes.inputLabelProps,
                }}
                FormHelperTextProps={{
                  className: classes.helperTextProps,
                }}
              />
            </Box>
          </Box>

          <Box className={classes.forgotPasswordContainer}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className={classes.rememberMeCheckbox}
                  size="small"
                />
              }
              label="Remember me for 30 days"
              className={classes.rememberMeLabel}
            />
            <Link to="/forgot/password" className={classes.forgotPasswordLink}>
              Forgot password?
            </Link>
          </Box>

          <PrimaryButton
            hideIcon
            type="submit"
            hasCustomLabel={true}
            style={{
              width: "100%",
              height: "46px",
              marginTop: "8px",
              background: isLoggingIn
                ? "linear-gradient(135deg, #94a3b8, #64748b)"
                : "linear-gradient(135deg, #3b82f6, #1d4ed8)",
              color: "#ffffff",
              borderRadius: "16px",
              fontSize: "16px",
              fontWeight: "600",
              textTransform: "none",
              boxShadow: isLoggingIn
                ? "0 2px 8px rgba(100, 116, 139, 0.2)"
                : "0 4px 20px rgba(59, 130, 246, 0.3)",
              border: "none",
              "&:hover": {
                background: isLoggingIn
                  ? "linear-gradient(135deg, #94a3b8, #64748b)"
                  : "linear-gradient(135deg, #2563eb, #1e40af)",
                boxShadow: isLoggingIn
                  ? "0 2px 8px rgba(100, 116, 139, 0.2)"
                  : "0 6px 25px rgba(59, 130, 246, 0.4)",
              },
            }}
          >
            {isLoggingIn ? "Signing In..." : "Sign In"}
          </PrimaryButton>
        </form>
      </Box>
    </Box>
  );
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  isLoggingIn: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = ({ AuthReducer }) => ({
  isAuthenticated: AuthReducer.isAuthenticated,
  isLoggingIn: AuthReducer.isLoggingIn,
  error: AuthReducer.error,
});

function mapDispatchToProps(dispatch) {
  return {
    login: (...args) => dispatch(loginAction(...args)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Login);
